export default "__VITE_ASSET__609342d6__"